<template>
  <div>
    <div v-if="!dataLoaded">
      <b-skeleton type="button"></b-skeleton>
      <div class="card card-custom gutter-b mt-3">
        <div class="card-body">
          <!--begin::Top-->
          <div class="d-flex">
            <!--begin::Pic-->
            <div class="flex-shrink-0 mr-7">
              <div class="symbol symbol-50 symbol-lg-120">
                <b-skeleton width="150px" height="150px"></b-skeleton>
              </div>
            </div>
            <!--end::Pic-->
            <!--begin: Info-->
            <div class="flex-grow-1">
              <!--begin::Title-->
              <div class="d-flex align-items-center justify-content-between flex-wrap mt-2">
                <!--begin::User-->
                <div class="mr-3">
                  <!--begin::Name-->
                  <span
                    class="d-flex align-items-center text-dark text-hover-primary font-size-h5 font-weight-bold mr-3">
                    <b-skeleton width="90px"></b-skeleton> (<b-skeleton width="90px"></b-skeleton>)
                  </span>
                  <!--end::Name-->
                  <!--begin::Contacts-->
                  <div class="d-flex flex-wrap my-2">
                    <span class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                      <b-skeleton width="150px"></b-skeleton>
                    </span>
                  </div>
                  <!--end::Contacts-->
                </div>
                <!--begin::User-->
                <!--begin::Actions-->
                <div class="my-lg-0 my-1">
                  <b-skeleton type="button"></b-skeleton>
                </div>
                <!--end::Actions-->
              </div>
              <!--end::Title-->
              <!--begin::Content-->
              <div class="d-flex align-items-center flex-wrap justify-content-between">
                <!--begin::Description-->
                <div class="flex-grow-1 font-weight-bold text-dark-50 py-2 py-lg-2 mr-5">
                  <b-skeleton></b-skeleton>
                </div>
              </div>
              <!--end::Content-->
              <!--begin::pin-->
              <div class="d-flex align-items-center flex-wrap justify-content-between">
                <!--begin::pin-->
                <div class="flex-grow-1 font-weight-bold text-dark-50 py-2 py-lg-2 mr-5">
                  <b-skeleton width="190px"></b-skeleton>
                </div>
              </div>
              <!--end::pin-->
            </div>
            <!--end::Info-->
          </div>
          <!--end::Top-->
          <!--begin::Separator-->
          <div class="separator separator-solid my-7"></div>
          <!--end::Separator-->
          <!--begin::Bottom-->
          <div v-if="window.width >= 768" class="d-flex align-items-center flex-wrap">
            <!--begin: Item-->
            <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
              <span class="mr-4">
                <i class="flaticon-pie-chart icon-2x text-muted font-weight-bold"></i>
              </span>
              <div class="d-flex flex-column text-dark-75">
                <span class="font-weight-bolder font-size-sm">حساب بانکی</span>
                <span class="font-weight-bolder font-size-h5"><b-skeleton></b-skeleton></span>
              </div>
            </div>
            <!--end: Item-->
            <!--begin: Item-->
            <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
              <span class="mr-4">
                <i class="flaticon-piggy-bank icon-2x text-muted font-weight-bold"></i>
              </span>
              <div class="d-flex flex-column text-dark-75">
                <span class="font-weight-bolder font-size-sm">واحد پولی</span>
                <span class="font-weight-bolder font-size-h5"><b-skeleton></b-skeleton></span>
              </div>
            </div>
            <!--end: Item-->
            <!--begin: Item-->
            <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
              <span class="mr-4">
                <i class="flaticon-confetti icon-2x text-muted font-weight-bold"></i>
              </span>
              <div class="d-flex flex-column text-dark-75">
                <span class="font-weight-bolder font-size-sm">نوع درگاه</span>
                <span class="font-weight-bolder font-size-h5"><b-skeleton></b-skeleton></span>
              </div>
            </div>
          </div>
          <!--end::Bottom-->
        </div>
      </div>
      <div class="card card-custom gutter-b mt-3">
        <div class="card-body">
          <!--begin::Top-->
          <div class="d-flex">
            <!--begin::Pic-->
            <div class="flex-shrink-0 mr-7">
              <div class="symbol symbol-50 symbol-lg-120">
                <b-skeleton width="150px" height="150px"></b-skeleton>
              </div>
            </div>
            <!--end::Pic-->
            <!--begin: Info-->
            <div class="flex-grow-1">
              <!--begin::Title-->
              <div class="d-flex align-items-center justify-content-between flex-wrap mt-2">
                <!--begin::User-->
                <div class="mr-3">
                  <!--begin::Name-->
                  <span
                    class="d-flex align-items-center text-dark text-hover-primary font-size-h5 font-weight-bold mr-3">
                    <b-skeleton width="90px"></b-skeleton> (<b-skeleton width="90px"></b-skeleton>)
                  </span>
                  <!--end::Name-->
                  <!--begin::Contacts-->
                  <div class="d-flex flex-wrap my-2">
                    <span class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                      <b-skeleton width="150px"></b-skeleton>
                    </span>
                  </div>
                  <!--end::Contacts-->
                </div>
                <!--begin::User-->
                <!--begin::Actions-->
                <div class="my-lg-0 my-1">
                  <b-skeleton type="button"></b-skeleton>
                </div>
                <!--end::Actions-->
              </div>
              <!--end::Title-->
              <!--begin::Content-->
              <div class="d-flex align-items-center flex-wrap justify-content-between">
                <!--begin::Description-->
                <div class="flex-grow-1 font-weight-bold text-dark-50 py-2 py-lg-2 mr-5">
                  <b-skeleton></b-skeleton>
                </div>
              </div>
              <!--end::Content-->
              <!--begin::pin-->
              <div class="d-flex align-items-center flex-wrap justify-content-between">
                <!--begin::pin-->
                <div class="flex-grow-1 font-weight-bold text-dark-50 py-2 py-lg-2 mr-5">
                  <b-skeleton width="190px"></b-skeleton>
                </div>
              </div>
              <!--end::pin-->
            </div>
            <!--end::Info-->
          </div>
          <!--end::Top-->
          <!--begin::Separator-->
          <div class="separator separator-solid my-7"></div>
          <!--end::Separator-->
          <!--begin::Bottom-->
          <div v-if="window.width >= 768" class="d-flex align-items-center flex-wrap">
            <!--begin: Item-->
            <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
              <span class="mr-4">
                <i class="flaticon-pie-chart icon-2x text-muted font-weight-bold"></i>
              </span>
              <div class="d-flex flex-column text-dark-75">
                <span class="font-weight-bolder font-size-sm">حساب بانکی</span>
                <span class="font-weight-bolder font-size-h5"><b-skeleton></b-skeleton></span>
              </div>
            </div>
            <!--end: Item-->
            <!--begin: Item-->
            <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
              <span class="mr-4">
                <i class="flaticon-piggy-bank icon-2x text-muted font-weight-bold"></i>
              </span>
              <div class="d-flex flex-column text-dark-75">
                <span class="font-weight-bolder font-size-sm">واحد پولی</span>
                <span class="font-weight-bolder font-size-h5"><b-skeleton></b-skeleton></span>
              </div>
            </div>
            <!--end: Item-->
            <!--begin: Item-->
            <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
              <span class="mr-4">
                <i class="flaticon-confetti icon-2x text-muted font-weight-bold"></i>
              </span>
              <div class="d-flex flex-column text-dark-75">
                <span class="font-weight-bolder font-size-sm">نوع درگاه</span>
                <span class="font-weight-bolder font-size-h5"><b-skeleton></b-skeleton></span>
              </div>
            </div>
          </div>
          <!--end::Bottom-->
        </div>
      </div>
    </div>
    <div v-if="dataLoaded">
      <addGateway v-if="moneyType != 1722" v-bind:afterdone="afterGatewayaddedit" :moneyType="moneyType"></addGateway>
      <addIntGateway v-else v-bind:afterdone="afterGatewayaddedit" :moneyType="moneyType"></addIntGateway>
      <b-alert variant="danger" :show="UserCOnfirmed < 1 && UserCOnfirmed != -1">
        <p>
          اطلاعات کاربری شما تایید نشده است. تا زمانی که اطلاعات خود را تایید
          نکنید امکان دریافت درگاه وجود ندارد
        </p>
        <p>
          برای تایید اطلاعات خود
          <a href="/dashboard">اینجا</a> کلیک کنید
        </p>
      </b-alert>
      <b-button v-if="UserCOnfirmed == 1" variant="success" v-b-modal.add-gateway-modal>درگاه اینترنتی جدید</b-button>

      <!-- <b-button
        class="ml-3"
        v-if="UserCOnfirmed == 1 && Shepalink == null"
        variant="success"
        href="/newspgateway"
        >لینک پرداخت جدید</b-button
      > -->
      <!--begin::Card-->
      <div class="card card-custom gutter-b mt-3" v-for="(x, index) in gatewayList" v-bind:key="x.id">
        <div class="card-body">
          <!--begin::Top-->
          <div class="d-flex">
            <!--begin::Pic-->
            <div class="flex-shrink-0 mr-7">
              <div class="symbol symbol-50 symbol-lg-120">
                <img alt="Pic" style="height: auto" :src="x.fileUrl" />
              </div>
            </div>
            <!--end::Pic-->
            <!--begin: Info-->
            <div class="flex-grow-1">
              <!--begin::Title-->
              <div class="d-flex align-items-center justify-content-between flex-wrap mt-2">
                <!--begin::User-->
                <div class="mr-3">
                  <!--begin::Name-->
                  <span
                    class="d-flex align-items-center text-dark text-hover-primary font-size-h5 font-weight-bold mr-3">
                    {{ x.website_name }}
                    <i v-if="x.mdid19_status == 1581" class="flaticon2-correct text-success icon-md ml-2"></i>
                  </span>
                  <!--end::Name-->
                  <!--begin::Contacts-->
                  <div class="d-flex flex-wrap my-2">
                    <span class="text-muted font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                      <b-icon icon="braces"></b-icon>
                      {{ x.category.title }}
                    </span>
                    <a :href="x.website" target="_blank" class="text-muted font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                      <b-icon icon="link45deg"></b-icon>
                      {{ x.website }}
                    </a>
                  </div>
                  <!--end::Contacts-->
                </div>
                <!--begin::User-->
                <!--begin::Actions-->
                <div class="my-lg-0 my-1" id="sharing-link">
                  <a :href="'transactions/' + x.id"
                    class="btn btn-sm btn-light-primary font-weight-bolder text-uppercase mr-2 btn-block mb-2">تراکنش
                    ها</a>
                  <editGateway :gatewayId="x.id" :afterDone="afterGatewayaddedit" class="mb-2"></editGateway>

                  <div class="">
                    <label for="social-link-price">جهت اشتراک لینک، مبلغ را وارد کنید</label>
                    <NumberSeprator id="social-link-price" v-model="priceLink[index]" placeholder="مبلغ (ریال)">
                    </NumberSeprator>
                    <!--                  <button type="button" v-on:click="isHidden[index] = true" v-if="priceLink[index] !== ''"-->
                    <!--                     class="-->
                    <!--                      btn btn-sm btn-light-primary-->
                    <!--                      font-weight-bolder-->
                    <!--                      text-uppercase-->
                    <!--                      mr-2-->
                    <!--                      btn-block-->
                    <!--                      mb-2-->
                    <!--                    ">ایجاد مبلغ مشخص-->
                    <!--                  </button>-->

                    <div class="row" v-if="priceLink[index] !== ''">
                      <!-- <a target="_blank" v-on:click.prevent="shareToWhatsApp(x, index)" title="اشتراک در واتس اپ"> -->
                      <i class="flaticon-whatsapp icon-2x text-muted font-weight-bold ml-10"
                        v-on:click.prevent="shareToWhatsApp(x, index)" style="cursor: pointer"
                        title="اشتراک در واتس اپ"></i>
                      <!-- </a> -->
                      <!-- <a target="_blank" v-on:click.prevent="shareToTelegram(x, index)" title="اشتراک در تلگرام"> -->
                      <i class="flaticon2-telegram-logo icon-2x text-muted font-weight-bold ml-10"
                        v-on:click.prevent="shareToTelegram(x, index)" style="cursor: pointer"
                        title="اشتراک در تلگرام"></i>
                      <!-- </a> -->
                      <i class="flaticon2-copy icon-2x text-muted font-weight-bold ml-10"
                        v-on:click="copyToClipBoard(x, index)" style="cursor: pointer" title="کپی لینک"></i>
                    </div>
                  </div>
                </div>
                <!--end::Actions-->
              </div>
              <!--end::Title-->
              <!--begin::Content-->
              <div class="d-flex align-items-center flex-wrap justify-content-between">
                <!--begin::Description-->
                <div class="flex-grow-1 font-weight-bold text-dark-50 py-2 py-lg-2 mr-5">
                  {{ x.description }}
                </div>
              </div>
              <!--end::Content-->
              <!--begin::pin-->
              <div v-if="x.mdid19_status == 1581" class="d-flex align-items-center flex-wrap justify-content-between">
                <!--begin::pin-->
                <div class="flex-grow-1 font-weight-bold text-dark-50 py-2 py-lg-2 mr-5">
                  کد درگاه (API Code):
                  <span class="text-success" style="direction: ltr; font-family: tahoma">{{ x.pin }}</span>
                </div>
              </div>
              <!--end::pin-->
            </div>
            <!--end::Info-->
          </div>
          <!--end::Top--->
          <!--begin::Separator-->
          <div v-if="window.width >= 768" class="separator separator-solid my-7"></div>
          <!--end::Separator-->
          <!--begin::Bottom-->
          <div v-if="window.width >= 768" class="d-flex align-items-center flex-wrap">
            <!--begin: Item-->
            <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
              <span class="mr-4">
                <i class="flaticon-pie-chart icon-2x text-muted font-weight-bold"></i>
              </span>
              <div class="d-flex flex-column text-dark-75">
                <span class="font-weight-bolder font-size-sm">{{
                  x.mdid14_direct_gate == 702 ? "کیف پول" : "حساب بانکی"
                }}</span>
                <span class="font-weight-bolder font-size-h5">{{
                  x.user_card != null
                    ? x.user_card.shaba_number
                    : x.wallet != null
                      ? x.wallet.wallet_name
                      : ""
                }}</span>
              </div>
            </div>
            <!--end: Item-->
            <!--begin: Item-->
            <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
              <span class="mr-4">
                <i class="flaticon-piggy-bank icon-2x text-muted font-weight-bold"></i>
              </span>
              <div class="d-flex flex-column text-dark-75">
                <span class="font-weight-bolder font-size-sm">واحد پولی</span>
                <span class="font-weight-bolder font-size-h5">{{
                  x.money_type.title
                }}</span>
              </div>
            </div>
            <!--end: Item-->
            <!--begin: Item-->
            <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
              <span class="mr-4">
                <i class="flaticon-confetti icon-2x text-muted font-weight-bold"></i>
              </span>
              <div class="d-flex flex-column text-dark-75">
                <span class="font-weight-bolder font-size-sm">وضعیت درگاه</span>
                <span class="font-weight-bolder font-size-h5">{{
                  x.status.title
                }}</span>
              </div>
            </div>
            <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
              <span class="mr-4">
                <svg viewBox="0 0 16 16" style="color: #8f8f8f" width="1.5em" height="1.5em" focusable="false"
                  role="img" aria-label="calendar date" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                  class="bi-calendar-date mx-auto b-icon bi" data-v-41be6633="">
                  <g data-v-41be6633="">
                    <path
                      d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z">
                    </path>
                    <path
                      d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z">
                    </path>
                  </g>
                </svg>
              </span>
              <div class="d-flex flex-column text-dark-75">
                <span class="font-weight-bolder font-size-sm">تاریخ تایید درگاه</span>
                <span class="font-weight-bolder font-size-h5">{{
                  x.mdid119_status_date
                }}</span>
              </div>
            </div>
          </div>
          <!--end::Bottom-->
        </div>
      </div>
      <!--end::Card-->
    </div>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import persianDate from "../../helpers/persianDate";
import { validationMixin } from "vuelidate";
import { email, required, minLength, url } from "vuelidate/lib/validators";
import addGateway from "./addGatewaymodal";
import addIntGateway from "./addIntGatewayModal";
import editGateway from "./editGateway";
import NumberSeprator from "@/components/numberSeprator";
import routesMap from '@/helpers/routesMap'
export default {
  mixins: [validationMixin],
  props: ["moneyType"],
  name: "gatewayList",
  components: {
    addGateway,
    addIntGateway,
    editGateway,
    NumberSeprator,
  },
  data: function () {
    return {
      sizeQR: 100,
      window: {
        width: 0,
        height: 0,
      },
      shareLinkId: null,
      priceLink: [],
      whatsappLink: "",
      socialLinkPrice: "",
      isHidden: [],
      dataLoaded: false,
      gatewayList: [],
      Shepalink: null,
      newgate: {
        websiteName: "",
        websiteAddress: "",
        description: "",
        supportPhone: "",
        wallet: "",
        category: "",
        moneyType: "",
        gatewayType: 701,
        card: "",
        mdid104_payment_priority: 1658,
        mdid105_payment_time: 1661,
      },
      userCards: [],
      userWallets: [],
      UserCOnfirmed: -1,
      routesMap,
    };
  },
  validations: {
    priceLink: {
      required,
    },
    newgate: {
      websiteName: {
        required,
        minLength: minLength(3),
      },
      website_en_name: {
        required,
        minLength: minLength(3),
      },
      websiteAddress: {
        required,
        url,
        minLength: minLength(3),
      },
      description: {
        minLength: minLength(3),
      },
      logo: {},
    },
  },
  methods: {
    shareToWhatsApp: function (x, index) {
      this.createPaymentGatewayShareLink(x, index);
      window.open(
        `https://web.whatsapp.com/send?l=en&text=${x.website}?amount=${this.priceLink[index]}&shareLinkId=${this.shareLinkId}`,
        "_blank"
      );
    },

    shareToTelegram: function (x, index) {
      this.createPaymentGatewayShareLink(x, index);
      window.open(
        `https://t.me/share/url?url=${x.website}?amount=${this.priceLink[index]}&shareLinkId=${this.shareLinkId}&text=لینک اشتراک برای درگاه شپا لینک ${x.website_name} به مبلغ ${this.priceLink[index]} ریال `,
        "_blank"
      );
    },

    copyToClipBoard: function (x, index) {
      var url = x.website.replace("http://", "").replace("https://", "");
      if (url.startsWith("she.pa")) {
        url = x.website;
      } else {
        url = "https://she.pa/" + url;
      }
      var result = this.createPaymentGatewayShareLink(x, index);
      result.then((res) => {
        if (this.shareLinkId) {
          navigator.clipboard.writeText(
            url +
            "?amount=" +
            this.priceLink[index] +
            "&shareLinkId=" +
            this.shareLinkId
          );
          this.$makeToast("success", "کپی", "لینک با موفقیت کپی شد.", 5000);
        }
      });
    },

    createPaymentGatewayShareLink: function (x, index) {
      return httpHelper
        .postData("paymentgateways/share-link", {
          price: this.priceLink[index],
          gateway_id: x.id,
          user_id: x.user_id,
        })
        .then((response) => {
          if (response.status === "success") {
            this.shareLinkId = response.data.id;
          }
        });
    },

    afterGatewayaddedit() {
      this.getGateWayList(this.moneyType != undefined ? this.moneyType : 483);
    },
    getGateWayList: function (moneyType) {
      httpHelper.setAuth();
      httpHelper
        .getData(`paymentgateways?money_type=${moneyType}`)
        .then((response) => {
          this.gatewayList = response.result;
          for (let i = 0; i < this.gatewayList.length; i++) {
            this.priceLink.push("");
            this.isHidden.push(false);
            if (this.gatewayList[i].mdid119_status_date != null) {
              this.gatewayList[i].mdid119_status_date =
                persianDate.getDateByFormat(
                  this.gatewayList[i].mdid119_status_date
                );
            } else {
              this.gatewayList[i].mdid119_status_date = "-";
            }
            httpHelper.getImage(this.gatewayList[i].logo).then((res) => {
              this.$set(this.gatewayList[i], 'fileUrl', res.result.url);
            });
          }
          this.Shepalink = this.gatewayList.find((o) => {
            return o.mdid14_direct_gate == 1673;
          });
          this.dataLoaded = true;
        })
        .finally(() => { });
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "درگاه های بانکی" }]);
    this.getGateWayList(this.moneyType != undefined ? this.moneyType : 483);
    httpHelper.getData("userconf/avg").then((res) => {
      this.UserCOnfirmed = parseFloat(res.result);
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    if (this.$route.params.new != null) {
      this.$bvModal.show("add-gateway-modal");
    }
  },
};
</script>
<style>
.hidden {
  display: none;
}
</style>
